import { AddAnnualMunicipalPropertyConsumptionInput, AddAnnualMunicipalPropertyConsumptionMutation } from "@/graphql/generated/graphql";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";

import { refreshMunicipalPropertyManagement } from "../../lib/refresh-municipal-property-management";

import { addAnnualMunicipalPropertyConsumptionMutationDocument } from "./add-annual-municipal-property-consumption-mutation.gql";

export function useAddAnnualMunicipalPropertyConsumption(): UseMutationResult<AddAnnualMunicipalPropertyConsumptionMutation, Error, AddAnnualMunicipalPropertyConsumptionInput> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: AddAnnualMunicipalPropertyConsumptionInput): Promise<AddAnnualMunicipalPropertyConsumptionMutation> =>
      createOperationClient("AddAnnualMunicipalPropertyConsumption").request(addAnnualMunicipalPropertyConsumptionMutationDocument, { input }),
    onSuccess: async (_data, { workspaceId, propertyId }): Promise<void> => {
      await refreshMunicipalPropertyManagement({ queryClient, scope: { workspaceId, propertyIdList: [propertyId] } }).catch(() => undefined);
    },
  });
}
